(() => {
  if (window.SpoiltNavigationReady) return;
  window.SpoiltNavigationReady = true;
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const warmed = new Set();
  let timer;
  function eligible(target) {
    const link = target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.search || url.hash || url.pathname === location.pathname) return;
    if (!/(^|\/)(products|collections)\/[^/]+/.test(url.pathname)) return;
    return url.href;
  }
  function warm(href) {
    if (!href || warmed.has(href) || warmed.size >= 8) return;
    warmed.add(href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = href;
    document.head.appendChild(hint);
  }
  document.addEventListener('pointerover', event => {
    clearTimeout(timer);
    const href = eligible(event.target);
    if (href) timer = setTimeout(() => warm(href), 120);
  }, {passive:true});
  document.addEventListener('pointerout', () => clearTimeout(timer), {passive:true});
  document.addEventListener('focusin', event => warm(eligible(event.target)));
  document.addEventListener('pointerdown', event => {
    if (event.button === 0) warm(eligible(event.target));
  }, {passive:true});
})();
